module.exports = __webpack_public_path__ + "static/bootstrap-card-header-7a4513086a1fa15cc6379b750f01e379.png";